import yourItemTypes from '../types/item'
import types from '../types/rent'
import {Map} from 'immutable'

const initialRoot = Map({
  forRent: false,
  price: 0,
  isFetching: false,
  error: '',
})

function root(state = initialRoot, action) {
  switch (action.type) {
    case yourItemTypes.FETCH_SUCCESS:
      return state.merge({
        forRent: action.payload.item.RentEnabled,
        price: action.payload.item.RentPrice + '',
      })
    case types.SET_FOR_RENT:
      return state.set('forRent', action.payload.forRent)
    case types.SET_PRICE:
      return state.set('price', action.payload.price)
    case types.SAVE:
      return state.merge({
        isFetching: true,
        error: '',
      })
    case types.SAVE_SUCCESS:
      return state.merge({
        isFetching: false,
        error: '',
      })
    case types.SAVE_FAIL:
      return state.merge({
        isFetching: false,
        error: action.payload.error,
      })
    default:
      return state
  }
}

export default root



// WEBPACK FOOTER //
// ./src/sections/yourItems/reducers/rent.js